"use client";

import { useStatsigClient } from "@repo/statsig";
import { useMemo } from "react";

/**
 * Hook to get free trial configuration based on Statsig experiment
 * Must be called within a React component
 *
 * @returns {Object} Object containing:
 *   - hasFreeTrial: boolean indicating if free trial is available
 *   - trialDays: number of trial days (0 if no trial)
 *   - groupName: the experiment group name
 */
export function useFreeTrialExperiment() {
  const { client } = useStatsigClient();

  const trialConfig = useMemo(() => {
    const experiment = client.getExperiment("free_trial");

    // Get the trial_days value from the experiment
    // The experiment should return trial_days as a parameter
    const trialDays = experiment.get("trial_days", 7);

    // Get the group name for debugging
    const groupName = experiment.groupName || "";

    // If trial_days > 0, there is a free trial
    const hasFreeTrial = trialDays > 0;

    return {
      hasFreeTrial,
      trialDays,
      groupName,
    };
  }, [client]);

  return trialConfig;
}
